export const FETCH_VIDEO_URL = 'FETCH_VIDEO_URL';
export const FETCH_VIDEO_URL_SUCCESS = 'FETCH_VIDEO_URL_SUCCESS';
export const FETCH_VIDEO_URL_ERROR = 'FETCH_VIDEO_URL_ERROR';
export const FETCH_FINANCIAL_WELLNESS_TILES = 'FETCH_FINANCIAL_WELLNESS_TILES';
export const FETCH_FINANCIAL_WELLNESS_TILES_SUCCESS = 'FETCH_FINANCIAL_WELLNESS_TILES_SUCCESS';
export const FETCH_FINANCIAL_WELLNESS_TILES_ERROR = 'FETCH_FINANCIAL_WELLNESS_TILES_ERROR';
export const FETCH_NAVIGATION_OPTIONS = 'FETCH_NAVIGATION_OPTIONS';
export const FETCH_NAVIGATION_OPTIONS_SUCCESS = 'FETCH_NAVIGATION_OPTIONS_SUCCESS';
export const FETCH_NAVIGATION_OPTIONS_ERROR = 'FETCH_NAVIGATION_OPTIONS_ERROR';
export const FETCH_TILES_INFORMATION = 'FETCH_TILES_INFORMATION';
export const FETCH_TILES_INFORMATION_SUCCESS = 'FETCH_TILES_INFORMATION_SUCCESS';
export const FETCH_TILES_INFORMATION_ERROR = 'FETCH_TILES_INFORMATION_ERROR';
export const FETCH_DISTRO_TILES_INFORMATION = 'FETCH_DISTRO_TILES_INFORMATION';
export const FETCH_DISTRO_TILES_INFORMATION_SUCCESS = 'FETCH_DISTRO_TILES_INFORMATION_SUCCESS';
export const FETCH_DISTRO_TILES_INFORMATION_ERROR = 'FETCH_DISTRO_TILES_INFORMATION_ERROR';


export const fetchVideoUrl = () => ({ type: FETCH_VIDEO_URL });
export const fetchVideoUrlSuccess = (payload: any) => ({ type: FETCH_VIDEO_URL_SUCCESS, payload });
export const fetchVideoUrlError = (payload: any) => ({ type: FETCH_VIDEO_URL_ERROR, payload });

export const fetchFinancialWellnessTiles = () => ({ type: FETCH_FINANCIAL_WELLNESS_TILES });
export const fetchFinancialWellnessTilesSuccess = (payload: any) => ({
  type: FETCH_FINANCIAL_WELLNESS_TILES_SUCCESS,
  payload,
});
export const fetchFinancialWellnessTilesError = (payload: any) => ({
  type: FETCH_FINANCIAL_WELLNESS_TILES_ERROR,
  payload,
});

export const fetchNavigationOptions = () => ({ type: FETCH_NAVIGATION_OPTIONS });
export const fetchNavigationOptionsSuccess = (payload: any) => ({
  type: FETCH_NAVIGATION_OPTIONS_SUCCESS,
  payload,
});
export const fetchNavigationOptionsError = (payload: any) => ({
  type: FETCH_NAVIGATION_OPTIONS_ERROR,
  payload,
});

export const fetchTilesInformation = () => ({ type: FETCH_TILES_INFORMATION });
export const fetchTilesInformationSuccess = (payload: any) => ({
  type: FETCH_TILES_INFORMATION_SUCCESS,
  payload,
});
export const fetchTilesInformationError = (payload: any) => ({
  type: FETCH_TILES_INFORMATION_ERROR,
  payload,
});

export const fetchDistroTilesInformation = () => ({ type: FETCH_DISTRO_TILES_INFORMATION });
export const fetchDistroTilesInformationSuccess = (payload: any) => ({
  type: FETCH_DISTRO_TILES_INFORMATION_SUCCESS,
  payload,
});
export const fetchDistroTilesInformationError = (payload: any) => ({
  type: FETCH_DISTRO_TILES_INFORMATION_ERROR,
  payload,
});
